import React from 'react';
import './Portada.css';

const Portada = ({ titulo }) => {
  return (
    <div className="portada">
      <div className="overlay">
        <h1>{titulo}</h1>
      </div>
    </div>
  );
};

export default Portada;